import { render, staticRenderFns } from "./IbanNumarasi.vue?vue&type=template&id=6d2e07c0"
import script from "./IbanNumarasi.vue?vue&type=script&lang=ts"
export * from "./IbanNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports